import positions from './positions';

export default {
  namespaced: true,
  modules: {
    positions,
  },
};
